<template>
  <div class="multiple-partner">
    <div class="edit-header">
      <div class="left">
        <img src="/static/img/common/header/back.svg" @click="pageback"/>
        <span class="page-name">{{ fromPlaylist ? '相手を変更して占う' : '占いに使う相手の情報を管理' }}</span>
      </div>
      <div v-if="showEdit" class="right" @click="editToggle">編集</div>
    </div>
    <p class="regist-num">{{ sortPartnerList.length }}/10</p>
    <div v-if="showAdd" class="list-item" @click="toDetail(0)">
      相手を追加
      <img src="/static/img/icons/ic_plus.svg">
    </div>
    <div v-if="!isEdit" class="list">
      <div class="list-item" v-for="target in sortPartnerList" :key="target.friend_id" @click="toDetail(target.friend_id)">
        <p class="target-name">
          {{ target.target_nickname ? target.target_nickname : 'ニックネーム未登録さん' }}
          <img v-if="target.is_current" src="/static/img/icons/ic_star.svg" width="15" height="15">
        </p>
        <img src="/static/img/icons/ic_next.svg">
      </div>
    </div>
    <div v-else class="edit-list">
      <div class="list-item" v-for="(target, idx) of sortPartnerList" :key="target.friend_id" >
        <div class="radio">
          <input type="radio" name="nickname_type" :id="`radio${idx}`" v-model="currentFriendId" :value="target.friend_id">
          <label :for="`radio${idx}`">{{ target.target_nickname ? target.target_nickname : 'ニックネーム未登録さん' }}</label>
          <img v-if="fromPlaylist && target.is_current" src="/static/img/icons/ic_star.svg" width="15" height="15">
        </div>
        <div class="to-detail" v-if="fromPlaylist" @click="toDetail(target.friend_id)">
          <img src="/static/img/icons/ic_next.svg">
        </div>
        <span v-else class="delete-btn" @click="deleteModalToggle(target)">削除</span>
      </div>
    </div>
    <div v-if="isEdit" class="bottom-btn">
      <submit-button type="submit" :text="fromPlaylist ? '占う' : '占う相手に設定'" design="fill" class="btn" @click="changeCurrent" />
      <submit-button type="button" text="キャンセル" class="btn" @click="cancel" />
    </div>
    <BaseModal v-if="showDeleteModal" label="削除" cancel="やっぱり残しておく" @confirm="deleteTarget" @close="deleteModalToggle">
      <p class="modal-contents">
        {{`${deleteItem.target_nickname ? deleteItem.target_nickname : 'ニックネーム未登録'}さんを削除しますね。`}}
      </p>
    </BaseModal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import SubmitButton from "@/utvStore/components/partials/SubmitButton"
import BaseModal from '@/utvStore/components/common/BaseModal'

export default {
  name: 'multiple-partner-list',
  components:{
    SubmitButton,
    BaseModal
  },
  data() {
    return {
      sortPartnerList: [],
      isEdit: false,
      showDeleteModal: false,
      deleteItem: {},
      currentFriendId: 1,
    }
  },
  props: {
    partnerList: {
      type: Array,
      default: () => []
    },
    fromPlaylist: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState({
      accessToken: state => state.auth.accessToken,
      friendList: state => state.account.friend_list
    }),
    showEdit(){
      return !this.isEdit && this.sortPartnerList.length > 0
    },
    showAdd(){
      return (!this.isEdit && this.sortPartnerList.length < 10) || (this.fromPlaylist && this.sortPartnerList.length < 10)
    }
  },
  watch:{
    partnerList:{
      handler(n,o){
        this.doInitPartner(n)
      }
    }
  },
  created(){
    this.isEdit = this.fromPlaylist ? true : false
    this.doInitPartner(this.partnerList)
  },
  mounted(){
    if(this.fromPlaylist){
      this.$el.querySelector('.regist-num').style.position = 'absolute'
      this.$el.querySelector('.bottom-btn').style.position = 'absolute'
    }
  },
  methods: {
    doInitPartner(partnerList){
      if(partnerList.length > 0){
        const currentFriendData = partnerList.find((v =>v.is_current))
        this.currentFriendId = currentFriendData ? currentFriendData.friend_id : 0
        this.sortPartnerList = this.sortList(partnerList)
      }
    },
    toDetail(friendId){
      if(this.fromPlaylist){
        this.$emit('to-detail', friendId)
      }else{
        if(this.isEdit) return
        if(friendId) location.href = `/user/account/target_profile?friend_id=${friendId}`
        else location.href = '/user/account/target_profile'
      }
    },
    cancel(){
      if(this.fromPlaylist) this.$emit('close')
      else this.editToggle()
    },
    editToggle(){
      this.isEdit = !this.isEdit
    },
    deleteModalToggle(target){
      this.showDeleteModal = !this.showDeleteModal
      if(this.showDeleteModal) this.deleteItem = target
      else this.deleteItem = {}
    },
    deleteTarget(){
      this.$store.dispatch(type.DELETE_FRIEND, {token: this.accessToken ,friendIdList: this.deleteItem.friend_id})
      .then((res) => {
        this.sortPartnerList = this.sortList(res)
        this.isEdit = false
        this.deleteModalToggle()
        })
    },
    changeCurrent(){
      this.$store.dispatch(type.TARGET_FRIEND, {token: this.accessToken ,friendId: this.currentFriendId})
      .then((res) => {
        this.sortPartnerList= this.sortList(res)
        if(this.fromPlaylist) this.$emit('change-current')
        else this.isEdit = false
        window.scrollTo(0, 0)
      })
    },
    sortList(list){
      // ★(current)の人が一番上 それ以外は登録日の降順
      const tmpList = list.slice();
      return tmpList.sort((a,b)=>{
        if(a.is_current && !b.is_current) return -1
        if(!a.is_current && b.is_current) return 1
        if(a.friend_id > b.friend_id) return  -1
        if(a.friend_id < b.friend_id) return 1
        return 0
      })
    },
    pageback(){
      if(/^.+(target_profile)/.test(document.referrer)){
        location.href = '/'
      } else {
        history.back()
      }
    }
  }
}</script>

<style lang="scss" scoped>
@import "../../../sass/commons/commonVariables.scss";
.multiple-partner{
  color: $col_base_black;
  padding: 35px 0;
  max-width: 580px;
  margin: auto;
  .edit-header{
    height: 44px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 90002;
    background: $col_def_gradient;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left{
      display: flex;
    }
    .right{
      font-size: 13px;
      color: $col_white;
      cursor: pointer;
    }
    .page-name{
      font-size: 16px;
      color: $col_white;
      margin-left: 10px;
    }
  }

  .regist-num{
    max-width: 580px;
    left: 50%;
    transform: translateX(-50%);
    position: fixed;
    height: 35px;
    top: 44px;
    width: 100%;
    background: rgba(255,255,255,0.37);
    padding: 0 20px;
    line-height: 35px;
    font-size: 12px;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.3);
    z-index: 1;
  }
  .list-item{
    position: relative;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    justify-content: space-between;
    border-bottom: 1px solid $col_temp_gray3;
    cursor: pointer;

    .target-name{
      display: flex;
      align-items: center;
      font-size: 14px;
      img{
        margin-left: 8px;
      }
    }
    .delete-btn{
      font-size: 13px;
      color: #FF7497;
      border: 1px solid;
      border-radius: 3px;
      padding: 1px 7px 0;
      line-height: 19px;
    }
    .to-detail{
      position: absolute;
      right: 20px;
      width: 80%;
      display: flex;
      justify-content: flex-end;
      @include mq('w580') {
        width: 90%;
      }
    }
  }
  .bottom-btn{
    display: flex;
    height: 80px;
    width: 100%;
    background: linear-gradient(74.13deg, #FFF3F5 21.4%, #F9F4FD 76.64%);
    box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.15);
    /* mix-blend-mode: multiply; */
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 90002;
    align-items: center;
    justify-content: center;
    padding: 0 25px;
    .btn{
      height: 40px;
      margin: 0 5px;
      max-width: 200px;
      box-shadow: none;
    }
  }
  .modal-contents{
    margin-bottom: 25px !important;
  }

  p{
    margin: 0;
  }

  .radio{
    display: flex;
    align-items: center;
    input[type="radio"]{
      display:none;
    }
    label{
      position: relative;
      padding-left: 30px;
      margin-right: 8px;
      font-size: 13px;
      line-height: 20px;
      cursor: pointer;
      white-space: pre;
      @include mq('w320'){
        font-size: 14px;
      }
    }
    label::before{
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border: 1px solid #D8D8D8;
      border-radius: 50%;
    }
    input[type="radio"]:checked + label::after{
      content: "";
      display: block;
      position: absolute;
      top: 0px;
      left: 0px;
      width: 20px;
      height: 20px;
      background: $col_temp_key1 no-repeat center / 12px 9px url('/static/img/icons/ic_check_white.svg');
      border-radius: 50%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/MultiplePartnerList.vue